import { Route } from '@angular/router';
import { LetMeInComponent } from './components/letmein/letmein.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { RestaurantOfferingComponent } from './components/restaurant-offering/restaurant-offering.component';
import { ExpansionPlanComponent } from './components/expansion-roadmap/expansion-plan.component';
import { LegalPageComponent } from './components/legal/legal-page.component';
import { LegalArticleComponent } from './components/legal/legal-article.component';

export const appRoutes: Route[] = [
    { path: '', component: DashboardComponent,  pathMatch: 'full'},
    { path: 'restaurant', component: RestaurantOfferingComponent,  pathMatch: 'full'},
    { path: 'expansion-plan', component: ExpansionPlanComponent,  pathMatch: 'full'},

    // Debug routes
    { path: 'letmein', component: LetMeInComponent,  pathMatch: 'full'},
    { path: 'letmeout', component: LetMeInComponent,  pathMatch: 'full'},


     {
    path: 'legal',
    component: LegalPageComponent,
    children: [
      { path: '', redirectTo: 'terms-and-conditions', pathMatch: 'full' },

      { path: 'terms-and-conditions', component: LegalArticleComponent, data: { key: 'terms-and-conditions' } },
      { path: 'cookies', component: LegalArticleComponent, data: { key: 'cookies' } },
      { path: 'accessibility', component: LegalArticleComponent, data: { key: 'accessibility' } },
      { path: 'impressum', component: LegalArticleComponent, data: { key: 'impressum' } },
      { path: 'privacy-policy', component: LegalArticleComponent, data: { key: 'privacy-policy' } },

      { path: 'terms-and-conditions/:file', component: LegalArticleComponent, data: { key: 'terms-and-conditions' } },
      { path: 'cookies/:file', component: LegalArticleComponent, data: { key: 'cookies' } },
      { path: 'accessibility/:file', component: LegalArticleComponent, data: { key: 'accessibility' } },
      { path: 'impressum/:file', component: LegalArticleComponent, data: { key: 'impressum' } },
      { path: 'privacy-policy/:file', component: LegalArticleComponent, data: { key: 'privacy-policy' } },
    ]
  },
];
